
      const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;

      if (GA_TRACKING_ID) {
        // Load gtag.js
        const gtagScript = document.createElement('script');
        gtagScript.setAttribute('async', '');
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
        document.head.appendChild(gtagScript);

        // Load GTM (if you still want it, optional)
        const gtmScript = document.createElement('script');
        gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NPLSZVZ');
    `;
        document.head.appendChild(gtmScript);

        // Setup dataLayer and gtag config
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', GA_TRACKING_ID);
      }
    